/* tslint:disable */
/* eslint-disable */
/**
 * Auth Service API
 * Auth Service API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const PermissionDtoAuthMethodRestrictionEnum = {
    Pin: 'pin'
};
/**
 * Check if a given object implements the PermissionDto interface.
 */
export function instanceOfPermissionDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('description' in value) || value['description'] === undefined)
        return false;
    if (!('resource' in value) || value['resource'] === undefined)
        return false;
    if (!('operation' in value) || value['operation'] === undefined)
        return false;
    return true;
}
export function PermissionDtoFromJSON(json) {
    return PermissionDtoFromJSONTyped(json, false);
}
export function PermissionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'resource': json['resource'],
        'operation': json['operation'],
        'authMethodRestriction': json['authMethodRestriction'] == null ? undefined : json['authMethodRestriction'],
    };
}
export function PermissionDtoToJSON(json) {
    return PermissionDtoToJSONTyped(json, false);
}
export function PermissionDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'resource': value['resource'],
        'operation': value['operation'],
        'authMethodRestriction': value['authMethodRestriction'],
    };
}
//# sourceMappingURL=PermissionDto.js.map